<template>
  <v-dialog v-model="showDialog" persistent max-width="400">
    <!-- Unexpected useless attribute on `<template>`  vue/no-useless-template-attributes
    @TODO check class="pa-0" -->
    <template v-if="!hideButton" v-slot:activator="{on}">
      <v-btn
          v-if="!noBtnText"
          outlined
          :color="color"
          class="mr-3 mb-3 mb-md-0"
          v-on="on"
      >
        <v-icon left>cloud_upload</v-icon>
        <span class="body-2">{{ $t('buttons:upload') }}</span>
      </v-btn>
      <v-btn
          v-else
          :color="color"
          v-on="on"
          icon
      >
        <v-icon>cloud_upload</v-icon>
      </v-btn>
    </template>
    <v-card class="pa-0">
      <v-card-title>
        <h2>{{ $t('components:documentation-upload-form.title') }}</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" lg="12" md="12" sm="12" xs="12">
              <v-text-field
                  v-model="documentation.name"
                  prepend-icon="article"
                  :label="$t('common:document-name')"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
              />

              <DateField
                  ref="start"
                  @update="(v) => (documentation.start = v)"
                  :isClearable="true"
                  :label="$t('common:valid-from')"
              />

              <DateField
                  ref="end"
                  @update="(v) => (documentation.end = v)"
                  :isClearable="true"
                  :label="$t('common:valid-until')"
              />

              <v-file-input
                  accept="image/*, application/pdf"
                  :label="$t('components:documentation-upload-form.file')"
                  show-size
                  v-model="file"
                  :rules="[
                      ruleRequired($t('utils:rules.requiredFile')),
                      ruleMaxFileSize(fileSizeLimit,$t('utils:rules.filesize', {size : '20 MB'}))
                    ]"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            @click="uploadDocumentation()"
        >{{ $t('buttons:save') }}
        </v-btn>
        <v-btn
            color="grey"
            @click="resetSettings()"
        >{{ $t('buttons:back') }}
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Documentation from "../../book/data/documentation";
import {ruleRequired, ruleMaxFileSize} from "../services/rules";
import DateField from "@/modules/core/components/DateField";

export default {
  name: "DocumentationUploadForm",
  components: {DateField},
  props: {
    color: String,
    hideButton: Boolean,
    noBtnText: Boolean,
    presetDocuName: String
  },
  data() {
    return {
      documentation: new Documentation(),
      file: null,

      showDialog: false
    }
  },
  computed: {
    fileSizeLimit() {
      return process.env.VUE_APP_UPLOAD_SIZE_DOCUMENT;
    }
  },
  methods: {
    ruleRequired,
    ruleMaxFileSize,
    uploadDocumentation() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$emit("postFile", {file: this.file, documentation: this.documentation});
      this.resetSettings();
    },

    resetSettings() {
      this.showDialog = false;
      this.$refs.form.reset();
      this.$refs.start.localDate = ''
      this.$refs.start.maskedDate = ''
      this.$refs.end.localDate = ''
      this.$refs.end.maskedDate = ''
    }
  },
  watch: {
    showDialog () {
      if (this.showDialog && this.presetDocuName) {
        this.documentation.name = this.presetDocuName;
      }
    }
  }
}
</script>
